import { cn } from "@/lib/utils";
import { VariantProps, cva } from "class-variance-authority";
import { HTMLAttributes, forwardRef } from "react";

const textVariants = cva("tracking-normal", {
  variants: {
    variant: {
      header: "text-black dark:text-white",
      desc: "text-gray-600 dark:text-gray-400",
      link: "text-blue-600 dark:text-blue-400",
    },
    size: {
      xs: "text-xs",
      sm: "text-sm",
      md: "text-base",
      lg: "text-lg",
      xl: "text-xl",
      xxl: "text-2xl",
      xxxl: "text-3xl",
      xxxxl: "text-4xl",
    },
    font: {
      light: "font-light",
      medium: "font-medium",
      normal: "font-normal",
      semibold: "font-semibold",
      bold: "font-bold",
    },
    spacing: {
      wide: "tracking-wider",
      wider: "tracking-widest",
    },
    case: {
      uppercase: "uppercase",
      lowercase: "lowercase",
      capitalize: "capitalize",
      normal: "normal",
    },
  },
  defaultVariants: {
    variant: "header",
    size: "md",
    font: "normal",
  },
});

interface Props
  extends HTMLAttributes<HTMLLabelElement>,
    VariantProps<typeof textVariants> {}

const Label = forwardRef<HTMLLabelElement, Props>(
  ({ children, className }, ref) => {
    return (
      <label
        ref={ref}
        className={cn(
          className,
          textVariants({ size: "sm", font: "semibold", variant: "desc" })
        )}
      >
        {children}
      </label>
    );
  }
);

// eslint-disable-next-line react-refresh/only-export-components
export { textVariants, Label };
